/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    familyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    picture?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    preferredUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    preferredTimezone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDto
     */
    timezoneUpdatedAt?: string;
}

/**
 * Check if a given object implements the UserProfileDto interface.
 */
export function instanceOfUserProfileDto(value: object): value is UserProfileDto {
    return true;
}

export function UserProfileDtoFromJSON(json: any): UserProfileDto {
    return UserProfileDtoFromJSONTyped(json, false);
}

export function UserProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'] == null ? undefined : json['user_id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'givenName': json['given_name'] == null ? undefined : json['given_name'],
        'familyName': json['family_name'] == null ? undefined : json['family_name'],
        'picture': json['picture'] == null ? undefined : json['picture'],
        'preferredUsername': json['preferred_username'] == null ? undefined : json['preferred_username'],
        'preferredTimezone': json['preferred_timezone'] == null ? undefined : json['preferred_timezone'],
        'timezoneUpdatedAt': json['timezone_updated_at'] == null ? undefined : json['timezone_updated_at'],
    };
}

export function UserProfileDtoToJSON(json: any): UserProfileDto {
    return UserProfileDtoToJSONTyped(json, false);
}

export function UserProfileDtoToJSONTyped(value?: UserProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'email': value['email'],
        'name': value['name'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'picture': value['picture'],
        'preferred_username': value['preferredUsername'],
        'preferred_timezone': value['preferredTimezone'],
        'timezone_updated_at': value['timezoneUpdatedAt'],
    };
}

